import * as React from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'hooks/use-redux'
import { openPlaylistRoute } from '@disco/state-management/actions/ExplorerActions'
import { clearSearch } from '@disco/state-management/actions/SearchActions'

export default function PlaylistRedirect() {
  const { playlistId } = useParams<{ playlistId: string }>()
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (playlistId) {
      const playlistIdNum = parseInt(playlistId, 10)
      dispatch(openPlaylistRoute(playlistIdNum))
      dispatch(clearSearch(true))
    }
  }, [playlistId, dispatch])

  return null
}
